/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { DonationBridge, DonationBridgeInterface } from '../DonationBridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'AsyncDisabled',
    type: 'error',
  },
  {
    inputs: [],
    name: 'EthTransferFailed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidAuxData',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidDoneeAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInputA',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'donee',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint64',
        name: 'index',
        type: 'uint64',
      },
    ],
    name: 'ListedDonee',
    type: 'event',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_auxData',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'donees',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_donee',
        type: 'address',
      },
    ],
    name: 'listDonee',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nextDonee',
    outputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

const _bytecode =
  '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';

type DonationBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: DonationBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class DonationBridge__factory extends ContractFactory {
  constructor(...args: DonationBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<DonationBridge> {
    return super.deploy(_rollupProcessor, overrides || {}) as Promise<DonationBridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_rollupProcessor, overrides || {});
  }
  override attach(address: string): DonationBridge {
    return super.attach(address) as DonationBridge;
  }
  override connect(signer: Signer): DonationBridge__factory {
    return super.connect(signer) as DonationBridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DonationBridgeInterface {
    return new utils.Interface(_abi) as DonationBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): DonationBridge {
    return new Contract(address, _abi, signerOrProvider) as DonationBridge;
  }
}
